/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-diaglab-association.reducer';

export const DoctorDiaglabAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorDiaglabAssociationEntity = useAppSelector(state => state.doctorDiaglabAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorDiaglabAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.detail.title">DoctorDiaglabAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.id}</dd>
          <dt>
            <span id="joiningDate">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.joiningDate">Joining Date</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.joiningDate}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="dutyStartTime">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.dutyStartTime">Duty Start Time</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.dutyStartTime}</dd>
          <dt>
            <span id="dutyEndTime">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.dutyEndTime">Duty End Time</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.dutyEndTime}</dd>
          <dt>
            <span id="permanent">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.permanent">Permanent</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.permanent ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.timestampEntry}</dd>
          <dt>
            <span id="association">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.association">Association</Translate>
            </span>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.association}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.doctor ? doctorDiaglabAssociationEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.lab">Lab</Translate>
          </dt>
          <dd>{doctorDiaglabAssociationEntity.lab ? doctorDiaglabAssociationEntity.lab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-diaglab-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-diaglab-association/${doctorDiaglabAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorDiaglabAssociationDetail;
